import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  LOCATIONS,
  NOTIFICATION,
  LOADING,
} from '../actionTypes';

const fetchLocations = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  if (payload.filterParams && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_LOCATIONS}?${payload.filterParams}`);
  }
  if (payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_LOCATIONS}${query}${sorting}&${payload.filterParams}`);
  }
  if (!payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_LOCATIONS}${query}${sorting}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.GET_LOCATIONS}${query}${sorting}`);
};

const postLocation = async payload => axiosAuthInstance.post(API_END_POINTS.GET_LOCATIONS, payload);

const patchLocation = async ({ gid, params }) => axiosAuthInstance.patch(`${API_END_POINTS.GET_LOCATIONS}/${gid}`, params);

export function* getLocations(action) {
  try {
    const { data: { entity } } = yield call(fetchLocations, action.payload);
    yield put({ type: LOCATIONS.SUCCESS, payload: entity });
  } catch (e) {
    yield put({ type: LOCATIONS.FAILED, payload: e.response.data });
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  }
}

export function* addLocation(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(postLocation, action.payload);
    const { data: { entity } } = yield call(fetchLocations, action.payload);
    yield put({ type: LOCATIONS.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.LOCATIONS.ADD_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}

export function* updateLocation(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(patchLocation, action.payload);
    const { data: { entity } } = yield call(fetchLocations, action.payload);
    yield put({ type: LOCATIONS.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.LOCATIONS.UPDATE_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}
